import React from "react";
import { FaLongArrowAltRight } from "react-icons/all";
import { useAuth } from "react-uicomp";
import Title from "../../common/title/Title.common";
import { FILE_URL } from "../../../config/Api.config";

export const StationChief = ({ chiefs }) => {
  // const { language } = useAuth();
  // const currentLanguage = getCurrentLanguage(language);

  // console.log("haha", chiefs);

  return (
    <div className="listofchief-wrapper">
      <div className="container">
        <div className="teams">
          <div className="cards-container">
            {chiefs?.length
              ? chiefs.reverse().map((item, index) => {
                  const { name, address, image, description } = item;
                  return (
                    <div className="wrapper" key={index}>
                      <div className="cards">
                        <div
                          className="image"
                          style={{
                            backgroundImage: `url(${FILE_URL + image})`,
                            backgroundPosition: "center",
                          }}></div>
                        <div className="information">
                          <div className="name">{name}</div>
                          <div className="designation">{address}</div>
                          <div
                            className="address"
                            styl={{ alignItems: "center" }}>
                            <div className="from">{description?.from?.en}</div>
                            <div style={{ position: "relative" }}>
                              <FaLongArrowAltRight
                                size={30}
                                style={{
                                  position: "absolute",
                                  top: -6,
                                  left: -9,
                                }}
                              />
                            </div>
                            <div className="to">
                              {description?.to?.en == ""
                                ? "Current Chief"
                                : description?.to?.en}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })
              : null}
          </div>
        </div>
      </div>
    </div>
  );
};
